import { getBaseDomain } from './other-fn';

export function showCookiesWarningBlock() {
    const cookiesWarningBlock = jQuery('[data-cookies-warning]');

    cookiesWarningBlock.on('click', '[data-cookies_use]', (e) => {
        const value = jQuery(e.target).attr('data-cookies_use') === 'accept' ? 'true' : '';

        jQuery.cookie('cookies_use_accept', value, { expires: 365, path: '/' });
        jQuery.cookie('cookies_use_accept', value, { expires: 365, path: '/', domain: '.' + getBaseDomain() });
        cookiesWarningBlock.hide();
    });

    if (jQuery.cookie('cookies_use_accept')) {
        cookiesWarningBlock.hide();
    }
}
